import * as React from 'react';
import {Omit} from '@material-ui/core';
import {FormDialogProps} from '../FormDialog';
import FormDialog from '../FormDialog/FormDialog';
import Alert, {AlertProps} from '@material-ui/core/Alert/Alert';
import {PropTypes} from '@material-ui/core';
import * as _ from 'lodash';

export enum InfoDialogVariants {
  Info = 'info',
  Error = 'error',
  AreYouSure = 'areYouSure',
}

export interface InfoDialogProps extends Omit<FormDialogProps, 'fields' | 'steps' | 'variant' | 'formName'> {
  variant?: InfoDialogVariants;
  instructionText?: {before?: React.ReactNode; after?: React.ReactNode};
  message?: React.ReactNode;
  AlertProps?: Partial<AlertProps>;
}

const getAlertColor = (variant: InfoDialogVariants): PropTypes.Color | 'error' => {
  switch (variant) {
    case InfoDialogVariants.Info:
      return 'primary';
    case InfoDialogVariants.AreYouSure:
      return 'secondary';
    case InfoDialogVariants.Error:
    default:
      return 'error';
  }
};

const InfoDialog: React.FunctionComponent<InfoDialogProps> = ({variant, AlertProps, ...props}) => {
  const {
    instructionText: {before, after},
    message,
  } = props;
  return (
    <FormDialog
      formName={_.uniqueId('infoDialog_')}
      content={
        <React.Fragment>
          {before}
          <Alert color={getAlertColor(variant)} {...AlertProps}>
            {message}
          </Alert>
          {after}
        </React.Fragment>
      }
      {...props}
    />
  );
};

InfoDialog.defaultProps = {
  variant: InfoDialogVariants.Info,
  disableExit: false,
  instructionText: {},
  message: '',
};
export default InfoDialog as React.FunctionComponent<InfoDialogProps>;
